import { render } from "./CourseMenu.vue?vue&type=template&id=66af4d71&scoped=true"
import script from "./CourseMenu.vue?vue&type=script&lang=js"
export * from "./CourseMenu.vue?vue&type=script&lang=js"

import "./CourseMenu.vue?vue&type=style&index=0&id=66af4d71&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66af4d71"]])

export default __exports__